import { render, staticRenderFns } from "./a2p-ai-check-panel.vue?vue&type=template&id=9bd5610a&scoped=true"
import script from "./a2p-ai-check-panel.vue?vue&type=script&lang=js"
export * from "./a2p-ai-check-panel.vue?vue&type=script&lang=js"
import style0 from "./a2p-ai-check-panel.vue?vue&type=style&index=0&id=9bd5610a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bd5610a",
  null
  
)

export default component.exports